// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2kapY","right":"Footer_right__ttnG7","buttons":"Footer_buttons__3Jwml"};